import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import {
  STORE_NOTIFICATION_CENTRAL_FETCH,
  STORE_STATUS_INITIALIZED,
  STORE_STATUS_FINISHED,
  STORE_NOTIFICATION_CENTRAL,
} from 'constants/store'

import { ErrorStore, NotificationCentral } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type NotificationCentralState = {
  notifications: NotificationCentral[]
}

type State = GenericState<NotificationCentralState>

export const initialState: State = {
  data: {
    notifications: [],
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchList = createAsyncThunk<
  NotificationCentralState,
  Promise<NotificationCentralState>,
  Payload
>(
  STORE_NOTIFICATION_CENTRAL_FETCH,
  async (promise: Promise<NotificationCentralState>, { rejectWithValue }) => {
    try {
      return await promise
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  NotificationCentralState,
  NotificationCentralState,
  Payload
>(fetchList, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_NOTIFICATION_CENTRAL,
  initialState,
  reducers: {
    markAsRead: (state, action: PayloadAction<{ notificationId: string }>) => {
      const notifications = state.data.notifications.map(
        (notification: NotificationCentral) =>
          notification.id === action.payload.notificationId
            ? { ...notification, read: true }
            : notification
      )

      return {
        ...state,
        data: {
          ...state.data,
          notifications,
        },
      }
    },
    updateInfiniteList: (
      state,
      action: PayloadAction<{ notifications: NotificationCentral[] }>
    ) => {
      return {
        ...state,
        data: {
          ...state.data,
          notifications: action.payload.notifications,
        },
        status: STORE_STATUS_FINISHED,
      }
    },
  },
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear, markAsRead, updateInfiniteList } = actions

export { clear, markAsRead, updateInfiniteList }

export default reducer
